// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--2fgKX","owner":"contact-module--owner--bz8mN","ownerImg":"contact-module--ownerImg--1iUb9"};